import { render, staticRenderFns } from "./TreatPackage.vue?vue&type=template&id=9a3e064a&"
import script from "./TreatPackage.vue?vue&type=script&lang=js&"
export * from "./TreatPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports